import React from 'react'
import styled from 'styled-components'
import { slide as Menu } from 'react-burger-menu'
import { Match } from '@reach/router'
import { getAnalytics, logEvent } from 'firebase/analytics'
import { navigate, Link } from 'gatsby'
import { navigateToLogin } from '@dabea/common/lib/utils/navigation'

import PAGES from '@dabea/common/lib/constants/pages'
import COLORS from '@dabea/common/lib/constants/colors'

import MenuIcon from '@dabea/common/lib/images/icons/menu-icon.svg'
import MenuIconClose from '@dabea/common/lib/images/icons/menu-icon-close.svg'
import Button from '@dabea/common/lib/components/Button'
import Logo from '@dabea/common/lib/components/Logo'
import MenuItem from './menuItem'

const styles = {
  logo: {
    textDecoration: 'none',
    width: 150,
    cursor: 'pointer',
  },
  nav: {
    flex: 1,
  },
  ul: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: 0,
  },
  font: {
    fontFamily: 'Lato, sans-serif',
    fontWeight: 600,
  },
}

const Header = styled.div`
  align-items: center;
  display: flex;
  left: 0;
  margin: 0 auto;
  padding: 3rem 3rem 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 10;

  @media (max-width: 900px) {
    padding-top: 1rem;
    padding-left: 1rem;
  }
`

const Login = styled.div`
  @media (max-width: 900px) {
    display: none;
  }
`

const MobileMenuWrap = styled.div`
  display: none;
  @media (max-width: 900px) {
    display: block;
  }
`

const TopMenu = () => (
  <Header data-test="frontpage-header">
    <Link to="/" style={styles.logo}>
      <Logo style={styles.logo} height={40} />
    </Link>
    <MobileMenuWrap>
      <Menu
        noOverlay
        disableAutoFocus
        right
        customBurgerIcon={<img src={MenuIcon} alt="menu" />}
        customCrossIcon={<img src={MenuIconClose} alt="menu-close" />}
      >
        <MenuItem sideMenu title="Forside" isActive={false} href="/" />
        <Match path={`/${PAGES.offer}`}>
          {({ match }) => (
            <MenuItem
              sideMenu
              title="Få et tilbud"
              isActive={!!match}
              href={`/${PAGES.offer}`}
            />
          )}
        </Match>
        <Match path={`/${PAGES.services}`}>
          {({ match }) => (
            <MenuItem
              sideMenu
              title="Ydelser"
              isActive={!!match}
              href={`/${PAGES.services}`}
            />
          )}
        </Match>
        <Match path={`/${PAGES.prices}`}>
          {({ match }) => (
            <MenuItem
              sideMenu
              title="Priser"
              isActive={!!match}
              href={`/${PAGES.prices}`}
            />
          )}
        </Match>
        <Match path={`/${PAGES.about}`}>
          {({ match }) => (
            <MenuItem
              sideMenu
              title="Om os"
              isActive={!!match}
              href={`/${PAGES.about}`}
            />
          )}
        </Match>
        <Match path={`/${PAGES.blog}`}>
          {({ match }) => (
            <MenuItem
              sideMenu
              title="Artikler"
              isActive={!!match}
              href={`/${PAGES.blog}`}
            />
          )}
        </Match>
        <MenuItem
          onClick={navigateToLogin}
          sideMenu
          title="Log ind"
          isActive={false}
        />
      </Menu>
    </MobileMenuWrap>
    <nav style={styles.nav}>
      <ul style={styles.ul}>
        <Match path={`/${PAGES.offer}`}>
          {({ match }) => (
            <MenuItem
              title="Få et tilbud"
              isActive={!!match}
              onClick={() => {
                logEvent(getAnalytics(), 'click_top_menu_prices')
                navigate(`/${PAGES.offer}`)
              }}
            />
          )}
        </Match>
        <Match path={`/${PAGES.services}`}>
          {({ match }) => (
            <MenuItem
              title="Ydelser"
              isActive={!!match}
              onClick={() => {
                logEvent(getAnalytics(), 'click_top_menu_services')
                navigate(`/${PAGES.services}`)
              }}
            />
          )}
        </Match>
        <Match path={`/${PAGES.prices}`}>
          {({ match }) => (
            <MenuItem
              title="Priser"
              isActive={!!match}
              onClick={() => {
                logEvent(getAnalytics(), 'click_top_menu_prices')
                navigate(`/${PAGES.prices}`)
              }}
            />
          )}
        </Match>
        <Match path={`/${PAGES.about}`}>
          {({ match }) => (
            <MenuItem
              title="Om os"
              isActive={!!match}
              onClick={() => {
                logEvent(getAnalytics(), 'click_top_menu_about')
                navigate(`/${PAGES.about}`)
              }}
            />
          )}
        </Match>
        <Match path={`/${PAGES.blog}`}>
          {({ match }) => (
            <MenuItem
              title="Artikler"
              isActive={!!match}
              onClick={() => {
                logEvent(getAnalytics(), 'click_top_menu_blog')
                navigate(`/${PAGES.blog}`)
              }}
            />
          )}
        </Match>
        <Login>
          <Button
            dataTest="login-button"
            onClick={() => {
              logEvent(getAnalytics(), 'click_top_menu_login')
              navigateToLogin()
            }}
            isRounded
            color={COLORS.BRAND_COLOR_ACCENT}
            textColor="white"
            height={50}
          >
            Log ind
          </Button>
        </Login>
      </ul>
    </nav>
  </Header>
)

export default TopMenu
